import * as React from 'react';
import { useYotpo } from '../../../utils/useYotpo';
import { useUrl } from '../../../../../providers/url';

const AskQuestion = ({ productId, title }) => {
  const { url } = useUrl();
  const { getAskQuestion } = useYotpo();
  return (
    <div
      className="yotpo-widget-instance"
      data-yotpo-instance-id={getAskQuestion()}
      data-yotpo-product-id={productId}
      data-yotpo-name={title}
      data-yotpo-url={url}
    />
  );
};

export default AskQuestion;
